export { default } from './BasketPriceStrip';